<cc-ng1-user-list
  [userStats]="userStats"
  [userList]="userList"
  [state]="state"
  [userIndex]="id"
  *ngIf="userStats && userList"
></cc-ng1-user-list>

<cc-section>
  <cc-ng1-user-new-invite
    [users]="userList"
    [stats]="accountStats"
    *ngIf="userList && accountStats"
  ></cc-ng1-user-new-invite>
</cc-section>
